import React from "react";
import { Link } from "react-router-dom";
import { ArrowRightIcon, ClockIcon } from "lucide-react";
import { otherDisciplines, services } from "../../data/services";
export function ServicesSection() {
  const prescription = services.filter(s => s.category === "prescription");
  const wellness = services.filter(s => s.category === "wellness");
  return <section id="soins" className="scroll-mt-20 bg-white" data-id="element-209" data-mp="3u269i47ct9ov">
      <div className="mx-auto max-w-6xl px-5 py-20 md:px-8 md:py-24" data-id="element-210" data-mp="lq0mioigwkmj">
        <div className="max-w-2xl" data-id="element-211" data-mp="qobx51gl6z5t">
          <h2 className="text-3xl font-semibold tracking-tight text-ink md:text-4xl" data-id="element-212" data-mp="qnab61y18s9b">
            Des soins sur ordonnance, et sans.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-213" data-mp="gpcm5c8cmrfn">
            Choisissez votre soin et réservez directement le créneau qui vous convient.
          </p>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-12 lg:gap-12" data-id="element-214" data-mp="2wj3ey8b757b3">
          <div className="lg:col-span-7" data-id="element-215" data-mp="31h50czw3hipq">
            <h3 className="text-sm font-semibold text-ink" data-id="element-216" data-mp="45ih01bqycme">Kinésithérapie · sur ordonnance</h3>
            <ul className="mt-4 divide-y divide-line border-y border-line" data-id="element-217" data-mp="3vccw333adhmh">
              {prescription.map(service => <li key={service.id} data-id="element-218" data-mp="d6qeih6fv9ff">
                  <Link to={`/reservation?service=${service.id}`} className="group flex items-start justify-between gap-6 py-6" data-id="element-219" data-mp="d7rtgwqksg2f">
                    <div data-id="element-220" data-mp="n338zh9t5rb8">
                      <p className="text-lg font-medium text-ink transition-colors duration-150 group-hover:text-brand" data-id="element-221" data-mp="n2bds7k4hvlh">
                        {service.name}
                      </p>
                      <p className="mt-1.5 max-w-md text-sm leading-relaxed text-muted" data-id="element-222" data-mp="vz2fp0lcw4nz">{service.description}</p>
                      <p className="mt-3 flex items-center gap-3 text-xs text-muted" data-id="element-223" data-mp="rxqpotyklhf9">
                        <span className="inline-flex items-center gap-1" data-id="element-224" data-mp="15t1h1xdlvkev">
                          <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-225" data-mp="10xm3z7nf9sji" />
                          {service.duration} min
                        </span>
                        <span aria-hidden="true" data-id="element-226" data-mp="2jqb3cvk3r8b">·</span>
                        <span data-id="element-227" data-mp="2i5gxod5maaz">{service.price}</span>
                      </p>
                    </div>
                    <span className="mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-line text-brand transition-colors duration-150 group-hover:border-brand group-hover:bg-brand group-hover:text-white" data-id="element-228" data-mp="7h8aocnoou3n">
                      <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-229" data-mp="m7pn0r1ux4fb" />
                      <span className="sr-only" data-id="element-230" data-mp="q9t0fl836j38">Réserver {service.name}</span>
                    </span>
                  </Link>
                </li>)}
            </ul>
          </div>

          <div className="flex flex-col rounded-3xl bg-brand p-8 text-white lg:col-span-5 lg:p-10" data-id="element-231" data-mp="v6jddzolgykf">
            <h3 className="text-2xl font-semibold" data-id="element-232" data-mp="2x0ac6u9iacmg">Sans ordonnance</h3>
            <p className="mt-3 text-sm leading-relaxed text-white/80" data-id="element-233" data-mp="2x0irest3pu0t">
              Prévention et bien-être, accessibles à tous : pas besoin de prescription médicale.
            </p>
            <ul className="mt-8 space-y-6" data-id="element-234" data-mp="2kp9d0spo4c8b">
              {wellness.map(service => <li key={service.id} className="border-t border-white/15 pt-6" data-id="element-235" data-mp="2frzkv5aw9mgs">
                  <div className="flex items-baseline justify-between gap-4" data-id="element-236" data-mp="2asmptx9vd934">
                    <p className="text-lg font-medium" data-id="element-237" data-mp="38fddir7k7vv3">{service.name}</p>
                    <p className="whitespace-nowrap text-lg font-semibold" data-id="element-238" data-mp="38dj161actc2m">{service.price}</p>
                  </div>
                  <p className="mt-1.5 text-sm leading-relaxed text-white/75" data-id="element-239" data-mp="2yhfqg71fs542">{service.description}</p>
                  <Link to={`/reservation?service=${service.id}`} className="mt-4 inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-brand transition-colors duration-150 hover:bg-accent hover:text-ink" data-id="element-240" data-mp="2ufuhgws0waz5">
                    Réserver · {service.duration} min
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <p className="mt-12 text-sm text-muted" data-id="element-241" data-mp="3bpog6exlmlo4">
          Également au cabinet : <span className="font-medium text-ink" data-id="element-242" data-mp="2x08q715w6k9h">{otherDisciplines.join(", ")}</span>.{" "}
          <Link to="/therapeutes" className="font-medium text-brand underline-offset-4 hover:underline" data-id="element-243" data-mp="31xioz7f6889z">
            Découvrir les thérapeutes
          </Link>
        </p>
      </div>
    </section>;
}